import { DeviceInfo } from 'qunar-react-native';
import debugHost from '../Utils/debugHost';
import getQueryParam from '../Utils/getQueryParam';

const { isWeb } = DeviceInfo;
const RN_HOST = 'https://order.qunar.com';
const RN_PATH_ORDER = '/api/wireless/order/aggregation/query.do';
// qrn fetch 请求的host作为默认地址
let HOTS = RN_HOST;
let benefitHost = 'https://homefront.qunar.com';
let wechatHost = 'https://wxapp.qunar.com';
let memberHost = 'https://membersys.qunar.com';
let isFromChannel = false;
// let benefitHost = 'http://l-noah6dkdisz231.auto.beta.cn0.qunar.com:8080';
// let wechatHost = 'http://l-noah6kz9uwmcc1.auto.beta.cn0:7070';

if(DeviceInfo?.platform?.toUpperCase() === 'WEB'){
    // web端，注意跨域问题
    HOTS = benefitHost = wechatHost = window.location.origin;
    // HOTS = 'https://touch.qunar.com';
} else if(DeviceInfo?.platform?.toUpperCase() === 'WECHAT') {
    if (__wxConfig.envVersion === "develop") {
        HOTS = benefitHost = wechatHost = 'https://wxapp.beta.qunar.com';
    } else {
        HOTS = benefitHost = wechatHost = 'https://wxapp.qunar.com';
    }
}

if(isWeb && getQueryParam('fromChannel')){
    isFromChannel = true;
    document.title = '去哪儿网 订单列表';
}

// HOTS = 'http://dev.qunar.com';

// HOTS = 'http://yapi.corp.qunar.com/mock/6603/order-three';
// HOTS = 'http://l-noah6lisjb10f1.auto.beta.cn0.qunar.com:9002';
// HOTS = 'http://ordercenter-ms-noah.beta.qunar.com';
// HOTS = 'http://orderbeta.qunar.com';

// HOTS = 'http://l-userorder1.user.cn1.qunar.com:8080';

// HOTS = 'http://l-noah6pkrzn95q1.auto.beta.cn0.qunar.com:9002';


// HOTS = 'http://l-userorder1.user.cn1.qunar.com:8080';

const URLS = {
    // orderlist: `${HOTS}/api/wireless/order/query.do`, // ***
    // orderListThree: `${HOTS}/api/wireless/order/aggregation/query.do`, // ***
    RN_ORDER_LIST: `${RN_HOST}${RN_PATH_ORDER}`,
    orderlist: isFromChannel ? `${HOTS}/api/wireless/order/aggregation/channelQuery.do` : `${HOTS}${RN_PATH_ORDER}`, // ***
    deleteOrder: `${HOTS}/api/wireless/recycled/delete.do`,
    cancelShare: `${HOTS}/api/wireless/share/cancle.do`,
    // hasUnbindOrder: `${HOTS}/api/wireless/order/query.do`, // ***
    hasShareOrder: `${HOTS}/api/wireless/share/query.do`, // ***
    bindShare: `${HOTS}/api/wireless/share/accept/all.do`, // ***
    autoBind: `${HOTS}/api/wireless/binding/multi/autoBind.do`, // ***
    clearServiceRedPoint: `${HOTS}/api/async/order/update.do`,
    // autoSearch: 'https://user.qunar.com/ajax/prenumQuery.jsp',
    // verifyMobileCode: `${HOTS}/api/wireless/verifyMobileCode.do`,
    // sendMobileCode: `${HOTS}/api/wireless/sendMobileCode.do`,
    // guideWeChatStatus: 'http://wxapp.qunar.com/api/wechat/getWechatBindState.do', // ***
    guideWeChatStatus: `${wechatHost}/api/wechat/getWechatBindState.do`, // ***
    benefitList: `${benefitHost}/hotelflow/banner`,

    serviceAction: `${HOTS}/api/async/order/query.do`,
    recommend:`${HOTS}/api/order/recommend.do`, // ***

    bindPrivilege: `${memberHost}/privilege/flight/bindPrivilege`, // 会员权益绑定接口

    searchUrl:`${HOTS}/api/order/search/query.do`
};

export { HOTS };

export default debugHost(URLS, HOTS);
